export default "/_next/static/images/12f8bb92d70a8c576df0ce64651b8eb9.jpg";